import { type User } from '@avanta/shared/types/users';
import { type AppointmentWithDetails } from 'types/appointments';

export const PATIENT_SESSION_FILTER = {
  WITH_SESSION: 'withSession',
  WITHOUT_SESSION: 'withoutSession',
} as const;

export type PatientSessionFilter =
  (typeof PATIENT_SESSION_FILTER)[keyof typeof PATIENT_SESSION_FILTER];

export const getPatientName = (patient: Pick<User, 'firstName' | 'surname'>): string =>
  [patient.firstName, patient.surname].filter(Boolean).join(' ');

export const matchesSessionFilter = (
  patientId: string,
  appointmentsByPatientId: Map<string, AppointmentWithDetails>,
  selectedKey: PatientSessionFilter | undefined
): boolean => {
  if (!selectedKey) {
    return true;
  }

  const hasUpcomingSession = appointmentsByPatientId.has(patientId);

  return selectedKey === PATIENT_SESSION_FILTER.WITH_SESSION
    ? hasUpcomingSession
    : !hasUpcomingSession;
};
